module.exports = __webpack_public_path__ + "img/file-alt.b2d8ff8a.svg";